/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef} from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, useHistory } from "react-router-dom";
import { login, logoff,loadUserFromStorage } from "_services/oauth";
import axios from "axios";
import getCurrentUser from "utils/getCurrentUser";
import { authHeader } from "_helpers";
import store from "store";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import Slider from "@material-ui/core/Slider";
import Hidden from '@material-ui/core/Hidden';
import Datetime from 'react-datetime';
import Select from 'react-select';
// core components
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";

import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Fab from '@material-ui/core/Fab';


import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
// import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import TSUser from "components/Forms/TSUser"; 
import TSSelect2 from "components/Forms/TSSelect2";
import TSSelectMultiple from "components/Forms/TSSelectMultiple";
import TSText from "components/Forms/TSText";
//import TSLeaveForm from "components/Forms/TSLeaveForm"; 
import PdfFile from "views/Report/PdfFile";
import TSRadio from "components/Forms/TSRadio";
import TSCheckBox from "components/Forms/TSCheckBox";

import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import FastfoodIcon from '@material-ui/icons/Fastfood';
import LaptopMacIcon from '@material-ui/icons/LaptopMac';
import HotelIcon from '@material-ui/icons/Hotel';
import RepeatIcon from '@material-ui/icons/Repeat';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';

import { Collapse, Modal, ModalBody } from "reactstrap";
// import avatar from "assets/img/faces/marc.jpg";
import {
  Input,
  Label,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
} from "reactstrap";


import "react-datetime/css/react-datetime.css"
import "./custom-style.css";
import Leave from "layouts/Leave";
import { ContactsRounded, Description, Grade } from "@material-ui/icons";


const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none"
  },
   paper: {
    padding: '6px 16px',
  },
  secondaryTail: {
    backgroundColor: "gray",
  },
};

const primaryColor = "#af2cc5";

const useStyles = makeStyles((theme) => ({
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none"
  },
   paper: {
    padding: '6px 16px',
  },
  secondaryTail: {
    backgroundColor: theme.palette.secondary.main,
  },
  largeAvatar: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  biggerAvatar: {
    width: theme.spacing(20),
    height: theme.spacing(20),
  },
}));
//const useStyles = makeStyles(styles);

const Request = (props) => {

  const currentUser = getCurrentUser();

  const { location, ...other } = props;
  const user = useSelector((state) => state.auth.user);
  const history = useHistory();

  //parameter สำหรับ 
  //const _leaveRequestID = (props.match.params.LeaveRequestID !== undefined) ? props.match.params.LeaveRequestID : null;
  const _leaveRequestID = (location.state != null && (location.state.leaveRequestID != null && location.state.leaveRequestID != '')) ? location.state.leaveRequestID: null;




  var moment = require('moment');
  require('moment/locale/th');
  const [LeaveRequestID, setLeaveRequestID] = useState('');
  const [LeaveTypeKey, setLeaveTypeKey] = useState(null);
  const [IsUrgent, setIsUrgent] = useState(false);
  const [EnabledUrgent, setEnabledUrgent] = useState(false);
  const [StartDate, setStartDate] = useState("");
  const [StartDate2, setStartDate2] = useState(null);
  const [StartType, setStartType] = useState(0);

  const [IsMoreDate, setIsMoreDate] = useState(false);
  const [EndDate, setEndDate] = useState("");
  const [EndType, setEndType] = useState(0);
  const [LeaveReason, setLeaveReason] = useState('');
  const [LeaveReasonDelay, setLeaveReasonDelay] = useState('');
  const [MedicalCertificate, setMedicalCertificate] = useState('');

  const [ContactAddress, setContactAddress] = useState('');
  const [ContactPhone, setContactPhone] = useState('');
  const [UserName, setUserName] = useState('');

  const [TotalDate, setTotalDate] = useState(1);
  const [TotalHistory, setTotalHistory] = useState(0);
  const [TotalAll, setTotalAll] = useState(0);
  const [RequestBefore, setRequestBefore] = useState(0);

  const [modalHoliday, setModalHoliday] = useState(false);
  const [holidayText, setHolidayText] = useState('');
  const [currentDate, setcurrentDate] = useState(moment());
  const [holidays, setHolidays] = useState([]);

  const [isHovered, setIsHovered] = useState(false);
  const [isApprove, setIsApprove] = useState(true);
  const [isReceiveMoney, setIsReceiveMoney] = useState(true);
  const [ArrLeaveType, setArrLeaveType] = useState([]);
  const [ArrStandin, setArrStandin] = useState([]);
  const [ArrDepartmentBoss, setArrDepartmentBoss] = useState([]);
  const [ArrGroupworkBoss, setArrGroupworkBoss] = useState([]);
  const [ArrMissionBoss, setArrMissionBoss] = useState([]);
  const [ArrDirector, setArrDirector] = useState([]);
  const [LeaveApprove, setLeaveApprove] = useState([]);
  const [ApproveDirector, setApproveDirector] = useState(false);

  const [FlowLevel, setFlowLevel] = useState([]);

  const [LeaveHistory, SetLeaveHistory] = useState("");

  const [Standin, SetStandin] = useState("");
  const [DepartmentBoss, SetDepartmentBoss] = useState("");
    const [GroupworkBoss, SetGroupworkBoss] = useState("");
    const [MissionBoss, SetMissionBoss] = useState("");

    const [Director, SetDirector] = useState("");
   const [LeaveApproveKey, setLeaveApproveKey] = useState(0);
    const [ApproveTypeKey, setApproveTypeKey] = useState(0);
    const [ApproveDescription, setApproveDescription] = useState('เห็นควรอนุญาต');
    const [HRMoneyDesc, setHRMoneyDesc] = useState('');


  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [modalCancel, setModalCancel] = useState(false);
  const [modalApprove, setModalApprove] = useState(false);
  const [modalDirector, setModalDirector] = useState(false);
  const [modalHRApprove, setModalHRApprove] = useState(false);
  const [modal4, setModal4] = useState(false);
  const [errMsg, setErrMsg] = useState([]);
  const [modalError, setModalError] = useState(false);
  const [icon, setIcon] = useState("far fa-question-circle");
  const [icon2, setIcon2] = useState("far fa-question-circle");
  const [FullName, setFullName] = useState('');
  const [PositionName, setPositionName] = useState('');
  const [TypeGovName, setTypeGovName] = useState('');
  const [GroupText, SetGroupText] = useState("");

    const [isOpen, setIsOpen] = useState(false);
    const [isHR, setIsHR] = useState(false);
  const [isCancel, setIsCancel] = useState(false);
  //const [isEdit, setIsEdit] = useState(false);
    const [dateFocus, setDateFocus] = useState(false);

    const datetimeWorkaround = (value) => value === '' ? { value: '' } : {};

  const urgentList = [{ label:"ปกติ", value:0}, { label:"ด่วน", value:1} , { label:"ฉุกเฉิน", value:2}];
  const dateTypeList = [{ label:"ทั้งวัน", value:0}, { label:"ครึ่งวันเช้า", value:1} , { label:"ครึ่งวันบ่าย", value:2}];
  const dateTypeList2 = [{ label:"ทั้งวัน", value:0}, { label:"ครึ่งวันเช้า", value:1} ];

  const myRef = useRef(null);

  const hiddenStyle = {
    display: isHovered ? 'none' : 'block',
    color: 'red',
    //margin: '10px',
    marginLeft: '10px'
  };
  
  const visibleStyle = {
    display: isHovered ? 'block' : 'none',
    //margin: '10px',
    marginLeft: '10px'
  };


  const isEdit = (location.state != null && (location.state.leaveRequestID != null && location.state.leaveRequestID != ''));

  useEffect(() => {
    if (!currentUser || !currentUser.token) return;

    if (_leaveRequestID != null && _leaveRequestID != '') {
        props.history.push({
            pathname: '/leave/request',
            state: {
                leaveRequestID: _leaveRequestID
            }
        })
    }

    const userDepartments = Array.isArray(currentUser.userDepartment) ? currentUser.userDepartment : [];
    const _isHR = userDepartments.filter(u => u.departmentKey == 105
            || u.departmentKey == 108
      ).length > 0;
    setIsHR(_isHR);

    var _alt = [];
    axios.post("/api/v1/leave/type", {"IsApprove": true, "LeaveRequestID": (isEdit ? location.state.leaveRequestID : '00000000-0000-0000-0000-000000000000')})
    .then(
      result => {
            var json = JSON.parse(JSON.stringify(result.data.data)/*.split('"name":').join('"label":').split('"leaveTypeKey":').join('"value":')*/);
            setArrLeaveType(json)
            _alt = json;
        }, error => { console.log(error); }
    );  

    axios.post("/api/v1/myteam", {leaveRequestID: isEdit ? location.state.leaveRequestID: '00000000-0000-0000-0000-000000000000' })
    .then(
      result => {
            var json = JSON.parse(JSON.stringify(result.data.data)/*.split('"firstName":').join('"label":').split('"userName":').join('"value":')*/);
            
            const myteam = json.map((o) => ({
              ...o,
              value: o.userName.toLowerCase(),
              label: `${o.userProfile.firstName} ${o.userProfile.lastName}`
            }));
            


            const jsonMy = myteam.filter(e => e.userName.toLowerCase() == result.data.userName.toLowerCase() && e.isDefault)[0];
         
            if(!isEdit){
              setContactPhone(jsonMy.userProfile.mobilePhone);
              setContactAddress(jsonMy.userProfile.address);
            }

            const jsonStanin = myteam.filter(e => e.userName != result.data.userName && e.userLevelKey < 3)
            setArrStandin(jsonStanin)

            const jsonDept = myteam.filter(e => e.userName != result.data.userName && e.userLevelKey == 1 && jsonMy.userLevelKey < 1 /*e.userLevelKey == jsonMy.userLevelKey*/)
            setArrDepartmentBoss(jsonDept)

            const jsonGroup = myteam.filter(e => e.userName != result.data.userName && (e.userLevelKey == 2 && e.isDefault) && jsonMy.userLevelKey < 2)
            setArrGroupworkBoss(jsonGroup)

            const jsonMission = myteam.filter(e => e.userName != result.data.userName && (e.userLevelKey == 2 || e.userLevelKey == 3) && jsonMy.userLevelKey < 3)
            setArrMissionBoss(jsonMission)

        }, error => { console.log(error); }
      );  


      axios.post("/api/v1/director", { userName: "" })
          .then(
              result => {
                  var json = JSON.parse(JSON.stringify(result.data.data)/*.split('"firstName":').join('"label":').split('"userName":').join('"value":')*/);

                  const myteam = json.map((o) => ({
                      ...o,
                      value: o.userName,
                      label: `${o.userProfile.firstName} ${o.userProfile.lastName}`
                  }));

                  const jsonDirector = myteam.filter(e => e.userName != result.data.userName)
                  setArrDirector(jsonDirector)


              }, error => { console.log(error); }
          );  

    fetchHoliday(moment().format('YYYY/M'));

     //if(location.state != null)
    //{
      //if(location.state.leaveRequestID != null && location.state.leaveRequestID != '')
      //{

        //setIsEdit(true)
        if(isEdit)
        {
          axios({
            method: 'get',
              url: "/api/v1/leave/" + location.state.leaveRequestID
          })
          .then(
              resEdit => {
                var res=resEdit.data.data;
                setFullName(res.userView.titleName + res.userView.firstName + ' ' + res.userView.lastName)
                setPositionName(res.userView.positionName)
                setTypeGovName(res.userView.typeGov.name)

                var group = res.userView.userDepartment.find(t => t.isDefault == true);
                var _dep = (group != null && group.department != null) ? group.department : '';
                var _gw = (_dep != null && _dep.groupWork != null) ? _dep.groupWork : '';
                var _mission = (_gw != null && _gw.mission != null) ? _gw.mission : '';
                if(_dep.name === _gw.name){
                  var fullText = _gw.name+' '+_mission.name;
                  SetGroupText(fullText)
                } else {
                  var fullText = _dep.name+' '+ _gw.name+' '+_mission.name;
                  SetGroupText(fullText)
                }

                setIsCancel(res.isCancel)
                setLeaveTypeKey(res.leaveTypeKey)

                setStartDate(moment(res.startDate).format('YYYY-MM-DD').toString())
                setStartDate2(new Date(moment(res.startDate).format('YYYY-MM-DD')));
                setStartType(res.startDateType)
                setEndDate(moment(res.endDate).format('YYYY-MM-DD').toString())
                setEndType(res.endDateType)
                setUserName(res.userName)
                //handleLeaveType(_alt, res.leaveTypeKey, moment(res.startDate))
                //ให้ดึงสถิติจากที่บันทึกใน record (ไม่คำนวนใหม่เพราะจะสับสน) คำนวนใหม่เมื่อต้องการจะแก้ไข และเลือกวันใหม่
                var his = _alt.find(t => t.leaveTypeKey == res.leaveTypeKey);
                //console.log(his)
                var txt = 'ใช้วันลาแล้ว '; 
                var dt = (moment(res.startDate).isValid()) ? moment(res.startDate) : moment();
            
                if(his != null){
                  if(his.maxLeave != null && his.maxLeave  > 0) {
                    txt += res.totalHistory + '/'+ res.totalAll + ' วัน';
                  }
                  else{
                    if(dt.format('M') >=4 && dt.format('M') <= 9){
                      txt += res.totalHistory + '/'+ res.totalAll + ' วัน (ครึ่งปีหลัง)';  
                    }         
                    else{
                      txt += res.totalHistory + '/'+ res.totalAll+ ' วัน (ครึ่งปีแรก)';
                    }
                  }

                  setIsUrgent(res.isUrgent);
                  setTotalHistory(res.totalHistory);
                  setTotalAll(res.totalAll);
            
                  setEnabledUrgent(his.enabledUrgent == 1)
                  setRequestBefore(his.requestBefore)
                  SetLeaveHistory(txt);
   
                }










                setLeaveReason(res.leaveDesc)
                setLeaveReasonDelay(res.leaveDelayDesc)
                setMedicalCertificate(res.medicalCertificate)
  
                setContactAddress(res.contactAddress)
                setContactPhone(res.contactPhone)

                setTotalDate(res.totalDate)
  
                setIsMoreDate(moment(res.startDate) != moment(res.endDate))
                /*
                setMeetingID(res.meetingID)
                setMeetingName(res.meetingName)
                setStartDatetime(moment(res.startDatetime).format('YYYY-MM-DD').toString())
                setEndDatetime(moment(res.endDatetime).format('YYYY-MM-DD').toString())
                setStartTime(moment(res.startDatetime).format('HH:mm'))
                setEndTime(moment(res.endDatetime).format('HH:mm'))  
                setRoomKey(res.roomKey)
                setRoomStyleKey(res.roomStyleKey)
                setRoomTotalSeat(res.roomTotalSeat != null ? res.roomTotalSeat : 0)
                setMeetingDescription(res.meetingDescription)
                setContactPhone(res.contactPhone)
  
                setCreatorName(resEdit.data.creatorName);
                setEditerName(resEdit.data.editerName);
                setCancelerName(resEdit.data.cancelerName);
  
                setCreateDatetime(res.createDatetime);
                setLastEditDatetime(res.lastEditDatetime);
                setCancelDatetime(res.cancelDatetime);
                */

                //console.log(res.leaveApprove.find(t => t.approveTypeKey == 5).approveUserName)
                //if(LeaveTypeKey == 3 && ArrStandin.length > 0)
                if(res.leaveApprove.find(t => t.approveTypeKey == 5) != null)
                  SetStandin(res.leaveApprove.find(t => t.approveTypeKey == 5).approveUserName)

                if(res.leaveApprove.find(t => t.approveTypeKey == 4) != null)
                  SetDepartmentBoss(res.leaveApprove.find(t => t.approveTypeKey == 4).approveUserName)

                if(res.leaveApprove.find(t => t.approveTypeKey == 3) != null)
                  SetGroupworkBoss(res.leaveApprove.find(t => t.approveTypeKey == 3).approveUserName)

                  if (res.leaveApprove.find(t => t.approveTypeKey == 2) != null)
                      SetMissionBoss(res.leaveApprove.find(t => t.approveTypeKey == 2).approveUserName)

                  if (res.leaveApprove.find(t => t.approveTypeKey == 1 && t.approveUserName != null) != null)
                      SetDirector(res.leaveApprove.find(t => t.approveTypeKey == 1).approveUserName)
                      var check = res.leaveApprove.find(t => t.approveTypeKey == 1);
                      if(check != undefined && check.length > 0){
                        setApproveDirector(res.leaveApprove.find(t => t.approveTypeKey == 1).isApprove);
                      } else{
                        setApproveDirector(false);
                      }
                     



                setLeaveApprove(res.leaveApprove);

                handleFlowLevel(res.leaveType.systemTypeKey)

              },
              error => {
  
              }
          ); 
        }   

  }, []);

 
  const handleFlowLevel = (stk) => {
    axios.get('/api/v1/flowlevel?SystemKey=1&SystemTypeKey='+stk)
    .then(
      result => {
            setFlowLevel(result.data.data)


        }, error => { console.log(error); }
    );  
};



  const handleLeaveType = (arrleavetype, type, sdate) => {
    setLeaveTypeKey(type);
    //var his = ArrLeaveType.find(t => t.leaveTypeKey == type);
     var his = arrleavetype.find(t => t.leaveTypeKey == type);
    var txt = 'ใช้วันลาแล้ว ';

    var dt = (moment(sdate).isValid()) ? moment(sdate) : moment();

    if(his != null){
      if(his.maxLeave != null && his.maxLeave  > 0) {
        txt += his.totalLeave + '/'+ his.maxLeave + ' วัน';
        setTotalHistory(his.totalLeave);
        setTotalAll(his.maxLeave);
      }
      else{
        if(dt.format('M') >=4 && dt.format('M') <= 9){
          txt += his.half2Leave + '/'+ his.maxLeaveHalf2 + ' วัน (ครึ่งปีหลัง)';
          setTotalHistory(his.half2Leave);
          setTotalAll(his.maxLeaveHalf2);
        }
          
        else{
          txt += his.half1Leave + '/'+ his.maxLeaveHalf1+ ' วัน (ครึ่งปีแรก)';
          setTotalHistory(his.half1Leave);
          setTotalAll(his.maxLeaveHalf1);
        }
      }


      setEnabledUrgent(his.enabledUrgent == 1)
      setRequestBefore(his.requestBefore)
      SetLeaveHistory(txt);
    }
   



  };

  const handleSubmit = evt => {
    evt.preventDefault();
    var cntErr = 0;

    var errMsg = [];

    if(LeaveTypeKey == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุประเภทการลา"}</li>);
    }
      

    if(StartDate == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุวันที่ลา"}</li>);
    }

    if(IsMoreDate && EndDate == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุวันที่สิ้นสุดการลา"}</li>);
    }

    if(LeaveTypeKey != 3 && LeaveReason == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุเหตุผลการลา"}</li>);
    }

      
    if(ContactPhone == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุหมายเลขโทรศัพท์"}</li>);
    }
            
    if(ContactAddress == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุที่ติดต่อ"}</li>);
    }


    if(LeaveTypeKey == 3 && (Standin == null || Standin == ''))
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุผู้ปฏิบัติงานแทน"}</li>);
    }

/*
    if(ArrDepartmentBoss.length > 0  && (DepartmentBoss == null || DepartmentBoss == ''))
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุหัวหน้างาน"}</li>);
    }

    if(ArrGroupworkBoss.length > 0  && (GroupworkBoss == null || GroupworkBoss == ''))
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุหัวหน้ากลุ่มงาน"}</li>);
    }
*/
    if(ArrMissionBoss.length > 0  && (MissionBoss == null || MissionBoss == ''))
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุรองภารกิจ"}</li>);
    }


       
    /*
    if(Attendee == null || Attendee.length == 0)
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุผู้เข้าร่วม"}</li>);
    }
    */


    
    if (cntErr > 0) {
      setErrMsg(errMsg);
      setModalError(true);
    } else {
      setModal(true);
    }
  };

  const handleCancel = evt => {
    evt.preventDefault();
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");


    
    axios.put('/api/v1/leave/cancel/' + location.state.leaveRequestID, null)
          .then(
              result => {
 
                  if (result.data.result == 200) {
                      setIcon("far fa-question-circle");
                      setModalCancel(false)
                      setModal2(true)
                  }
                  else {
                      setIcon("far fa-question-circle");
                      setModalCancel(false)
                      setErrMsg(result.data.msg)
                      setModalError(true)
                  }

              },
              error => { console.log(error); }
    );  
    
  };



    const handleConfirmTest = evt => {
        evt.preventDefault();

        const _approve = [];

        var isFirst = false;

        if (LeaveTypeKey == 3 || (LeaveTypeKey == 2 && !IsUrgent)) {
            isFirst = true
            _approve.push({ approveTypeKey: 5, approveUserName: Standin, approveStatusKey: 1 })
        }


        if (ArrDepartmentBoss.length > 0 && DepartmentBoss != '') {
            if (!isFirst) {
                isFirst = true
                _approve.push({ approveTypeKey: 4, approveUserName: DepartmentBoss, approveStatusKey: 1 })
            }
            else {
                _approve.push({ approveTypeKey: 4, approveUserName: DepartmentBoss })
            }
        }


        if (ArrGroupworkBoss.length > 0 && GroupworkBoss != '') {
            if (!isFirst) {
                isFirst = true
                _approve.push({ approveTypeKey: 3, approveUserName: GroupworkBoss, approveStatusKey: 1 })
            }
            else {
                _approve.push({ approveTypeKey: 3, approveUserName: GroupworkBoss })
            }

        }


        if (ArrMissionBoss.length > 0) {
            if (!isFirst) {
                isFirst = true
                _approve.push({ approveTypeKey: 2, approveUserName: MissionBoss, approveStatusKey: 1 })
            } else {
                _approve.push({ approveTypeKey: 2, approveUserName: MissionBoss })
            }

        }

        var leave = {
            leaveTypeKey: LeaveTypeKey,
            isUrgent: IsUrgent,
            leaveDesc: LeaveReason,
            leaveDelayDesc: LeaveReasonDelay,
            medicalCertificate: MedicalCertificate,
            startDate: StartDate,
            //startDatetime: StartDate,
            startDateType: StartType,
            endDate: (IsMoreDate) ? EndDate : StartDate,
            //endDatetime: (IsMoreDate) ? EndDate : StartDate,
            endDateType: EndType,
            totalDate: TotalDate,
            contactAddress: ContactAddress,
            contactPhone: ContactPhone,
            totalHistory: TotalHistory,
            totalAll: TotalAll,
            leaveApprove: _approve,
        
        };

        console.log(leave) 

    };

  const handleConfirm = evt => {
    evt.preventDefault();
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");


      const _approve = [];

      var isFirst = false;

      {/* แก้ให้ลากิจฉุกเฉินมีผู้ปฏิบัติงานแทนเหมือนลากิจปกติ */}
      // if (LeaveTypeKey == 3 || (LeaveTypeKey == 2 && !IsUrgent )) {
      //if (LeaveTypeKey == 3 || (LeaveTypeKey == 2)) {
      let currentDate = new Date();
      if (LeaveTypeKey == 3 || (LeaveTypeKey == 2 && StartDate2 > currentDate)) {
          isFirst = true
          _approve.push({ approveTypeKey: 5, approveUserName: Standin, approveStatusKey: 1 })
      }


      if (ArrDepartmentBoss.length > 0 && DepartmentBoss != '') {
          if (!isFirst) {
              isFirst = true
              _approve.push({ approveTypeKey: 4, approveUserName: DepartmentBoss, approveStatusKey: 1 })
          }
          else {
              _approve.push({ approveTypeKey: 4, approveUserName: DepartmentBoss })
          }
      }
      

      if (ArrGroupworkBoss.length > 0 && GroupworkBoss != '') {
          if (!isFirst) {
              isFirst = true
              _approve.push({ approveTypeKey: 3, approveUserName: GroupworkBoss, approveStatusKey: 1 })
          }
          else {
              _approve.push({ approveTypeKey: 3, approveUserName: GroupworkBoss })
          }
            
      }
     
    
      if (ArrMissionBoss.length > 0) {
          if (!isFirst) {
              isFirst = true
              _approve.push({ approveTypeKey: 2, approveUserName: MissionBoss, approveStatusKey: 1 })
          } else {
              _approve.push({ approveTypeKey: 2, approveUserName: MissionBoss })
          }
            
      }
      
      //_approve.push({ approveTypeKey : 1, ApproveUserName : Direc })

    /*
    const _atd = [];
    Attendee.map((row) => (
      _atd.push({ userName : row.userName})
    ));

    const _asset = [];
    AssetKey.map((row) => (
      _asset.push({ assetKey : row.value, note : row.code})
    ));
    */

      

    var leave = {
      leaveTypeKey: LeaveTypeKey,
      isUrgent: IsUrgent,
      leaveDesc: LeaveReason,
      leaveDelayDesc: LeaveReasonDelay,
      medicalCertificate: MedicalCertificate,
      startDate: StartDate,
      //startDatetime: StartDate,
      startDateType: StartType,
      endDate: (IsMoreDate) ? EndDate : StartDate,
      //endDatetime: (IsMoreDate) ? EndDate : StartDate,
      endDateType: EndType,
      totalDate: TotalDate,
      contactAddress: ContactAddress,
      contactPhone: ContactPhone,
      totalHistory: TotalHistory,
      totalAll: TotalAll,
      leaveApprove: _approve,
      //leaveStatusKey: 0,
      //isApprove: true,
      //isCancel: true,
      //createrCode: "string",
      //createDT: "2023-10-20T04:42:21.320Z",
      //lastEditorCode: "string",
      //lastEditDT: "2023-10-20T04:42:21.320Z",
    };

    //console.log(leave) 


      
      //แก้ไข
      if(location.state != null && location.state.leaveRequestID != null && location.state.leaveRequestID != '')
      {

        // (url,body)
        axios.put('/api/v1/leave/'+location.state.leaveRequestID, leave)
        .then(
          result => {
            
            //console.log(result)

            if(result.data.result == 200)
            {
              setIcon("far fa-question-circle"); 
              setModal(false) 
              setModal2(true)
            }
            else
            {
              setIcon("far fa-question-circle"); 
              setModal(false) 
              setErrMsg(result.data.msg)
              setModalError(true) 
            }
  
          },
          error => {console.log(error);}
        );  
      }
      else{
        //ลงทะเบียนใหม่

        axios.post('/api/v1/leave', leave)
        .then(
          result => {  
            if(result.data.result == 200)
            {
              setLeaveRequestID(result.data.data.leaveRequestID)
              setIcon("far fa-question-circle"); 
              setModal(false) 
              setModal2(true)
            }
            else
            {
              setIcon("far fa-question-circle"); 
              setModal(false) 
              setErrMsg(result.data.msg)
              setModalError(true) 
            }

          },
          error => {console.log(error);}
        );  

      }
      
  };


  const GotoEdit = evt => {
    evt.preventDefault();

    if (location.state != null && location.state.leaveRequestID != null && location.state.leaveRequestID != '') {
        //setModal2(false)
        props.history.push({ pathname: '/leave/id/' + location.state.leaveRequestID })
    }
    else {
        props.history.push({ pathname: '/leave/id/' + LeaveRequestID })
    }

};


    const test = e => {
        myRef.current.scrollIntoView()
    };


    const handleSliderChange = (event, newTotal) => {
      setTotalDate(newTotal);
      var result = moment(StartDate);
      var addedDays = 0;

      if(newTotal == 0.5)
      {
        setStartType(2);
        setIsMoreDate(false)
      }
      else if (newTotal >= 1)
      {
        
        //setStartType(0);
        while (addedDays < (newTotal-1)) {
          result = result.add(1, 'days');
          
          if (result.day() !== 0 && result.day() !== 6 && holidays.find(h => moment(h.holidayDate).format("YYYYMMDD") === moment(result).format("YYYYMMDD")) == null   ) {
            addedDays++;
          }
        }
        
        if(StartType == 0)
        {
            if(Number(newTotal) === newTotal && newTotal % 1 !== 0)
              setEndType(1)
            else
              setEndType(0)
        }
        else if (StartType == 2)
        {
          if(Number(newTotal) === newTotal && newTotal % 1 !== 0)
            setEndType(0)
          else
          {
            setEndType(1)
            result = result.add(1, 'days');
          }            
        }
        setIsMoreDate(newTotal > 1)

      }




      setEndDate(moment(result).format('YYYY-MM-DD').toString())
    };

    const handleIsMoreDate = (imd) => {

      setIsMoreDate(imd)

      CalculateDayLength(StartDate, StartType, EndDate, EndType, imd);

      

     

    }


    const handleStartType = (type) => {
      setStartType(type);

      if(type == 1 || type == 2)
      {
        setTotalDate(0.5);
        setIsMoreDate(false)
      }  
      else {
        CalculateDayLength(StartDate, type, EndDate, EndType, IsMoreDate);
      }

    }

    const handleEndType = (type) => {
      setEndType(type);
      CalculateDayLength(StartDate, StartType, EndDate, type, IsMoreDate);
    }



    const handleStartDate = (date) => {
      setStartDate(date);
      setStartDate2(new Date(date));
      CalculateDayLength(date, StartType, EndDate, EndType, IsMoreDate);

      handleLeaveType(ArrLeaveType, LeaveTypeKey, date);


  }

  const handleEndDate = (date) => {
    setEndDate(date);
    CalculateDayLength(StartDate, StartType, date, EndType, IsMoreDate);



}

    const CalculateDayLength = (sd,sdt,ed,edt,imd) => {
      
      if(imd)
      {
        var body = {
          startDate : sd,
          startDateType: sdt,
          endDate: ed,
          endDateType: edt,
        }
  
        axios.post('/api/v1/leave/daylength', body)
        .then(
          result => {
              setTotalDate(result.data.totalDate)
  
            }, error => { console.log(error); }
        );  
      }
      else
      {
        if(sdt == 0)
          setTotalDate(1)
        else
          setTotalDate(0.5)
      }

     
    ;}

    const fetchHoliday = (yearMonth) => {


      axios.get('/api/holiday/' + yearMonth)
      .then(
        result => {
              setHolidays(result.data.data)


          }, error => { console.log(error); }
      );  



  };

  const handleCurrentDate = (dayAmt, unit) => {
      var curr = moment(currentDate).add(dayAmt, unit)
      setcurrentDate(curr);
      fetchHoliday(curr.format('YYYY/M'));
      return false;
  }

  const handleNavigate = (nextView, currentView, currDate) => {
      if (nextView == 'days') {
          setcurrentDate(currDate);
          fetchHoliday(currDate.format('YYYY/M'));
      }
      return nextView;
  }

  const handleHoliday = (txt) => {
      setHolidayText(txt);
      setModalHoliday(true);
  }



  function isDateValid(e, selectedDate) {
      var holiday = holidays.find(h => moment(h.holidayDate).format("YYYYMMDD") === moment(e).format("YYYYMMDD"))
      //return current.day() !== 0 && current.day() !== 6;
      if (holiday != null)
          return false
      else
      {
         

          var dt = (new Date()).setDate((new Date().getDate() - 2));

          if (LeaveTypeKey == 1 || (LeaveTypeKey == 2 && IsUrgent)) 
              dt = moment(new Date()).subtract(3, 'months');
          else if(LeaveTypeKey == 2 && !IsUrgent)
            dt = (new Date()).setDate((new Date().getDate() + (RequestBefore-1)));
          else if(LeaveTypeKey == 3)
            dt = (new Date()).setDate((new Date().getDate() + (RequestBefore-1)));


                let count = 0;
                let currentDate = new Date();
                while (currentDate <= dt) {
                    // getDay returns 0 for Sunday and 6 for Saturday
                    if (currentDate.getDay() === 0 || currentDate.getDay() === 6) {
                        count++;
                    }
                    else
                    {
                      //นับวันหยุดแล้วมมา count++
                      var hd = holidays.find(h => moment(h.holidayDate).format("YYYYMMDD") === moment(currentDate).format("YYYYMMDD"))
                      if(hd != null)
                        count++;
                    }
                    currentDate.setDate(currentDate.getDate() + 1);
                }
                dt = (new Date(dt)).setDate((new Date(dt).getDate() + count));
                //console.log(moment(dt).format("YYYY-MM-DD"))




          return (e.day() !== 0 && e.day() !== 6 && e >= dt)
      }
  }

  function isDateValid2(e, selectedDate) {
    var holiday = holidays.find(h => moment(h.holidayDate).format("YYYYMMDD") === moment(e).format("YYYYMMDD"))
    //return current.day() !== 0 && current.day() !== 6;
    if (holiday != null)
        return false
    else
        return (e.day() !== 0 && e.day() !== 6 && moment(e) >= moment(StartDate) )
}

  function renderDay(props, currentDate, selectedDate) {
      var holiday = holidays.find(h => moment(h.holidayDate).format("YYYYMMDD") === moment(currentDate).format("YYYYMMDD"))
      var hdt = (holiday != null) ? holiday.name : '';

      // Adds 0 to the days in the days view
      if ((props.className.indexOf('rdtDisabled') >= 0) && (currentDate.day() !== 0 && currentDate.day() !== 6 && currentDate > (new Date()).setDate((new Date().getDate() - 1)))) {
          props.className += ' text-danger';
          //return <td {...props} style={{ textDecoration: 'Line-Through' }}>{currentDate.date()}</td>;
          return <td key={currentDate} >
              <button
                  onClick={e => handleHoliday(hdt)}
                  className="btn btn-danger btn-icon btn-round" style={{ background: 'red' }}
              >
                  <span className="text-white" style={{ textDecoration: 'Line-Through' }}>{currentDate.date()}</span>
              </button>
          </td>; 
      }
      else {
          return <td {...props}>{currentDate.date()}</td>;
      }
    }




  const handleApprove = evt => {
    evt.preventDefault();
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

      var body = {
        isApprove : isApprove,
        approveDescription: ApproveDescription,
      }
        
        axios.put('/api/v1/leave/approve/' + LeaveApproveKey, body)
              .then(
                  result => {

                      if (result.data.result == 200) {
                          setIcon("far fa-question-circle");
                          setModalApprove(false)
                          setModal2(true)
                      }
                      else {
                          setIcon("far fa-question-circle");
                          setModalApprove(false)
                          setErrMsg(result.data.msg)
                          setModalError(true)
                      }

                  },
                  error => { console.log(error); }
        );
        
    }



    const handleHRApprove = evt => {
        evt.preventDefault();


        var cntErr = 0;

        var errMsg = [];

        if(Director == null || Director == '')
        {
          cntErr+=1;
          errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุผู้ลงนามสูงสุด"}</li>);
        }

        if (cntErr > 0) {
          setErrMsg(errMsg);
          setModalError(true);
        } else {


            setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

            var body = {
                totalDate: TotalDate,
                totalHistory: TotalHistory,
                totalAll: TotalAll,
                hrMoneyDesc: HRMoneyDesc,
                isReceiveMoney: isReceiveMoney,
                leaveApprove: [{
                    isApprove: isApprove,
                    approveDescription: ApproveDescription,
                    approveUserName : Director
                }]  
            }

            axios.put('/api/v1/leave/hrapprove/' + LeaveApproveKey, body)
                .then(
                    result => {

                        if (result.data.result == 200) {
                            setIcon("far fa-question-circle");
                            setModalApprove(false)
                            setModal2(true)
                        }
                        else {
                            setIcon("far fa-question-circle");
                            setModalApprove(false)
                            setErrMsg(result.data.msg)
                            setModalError(true)
                        }

                    },
                    error => { console.log(error); }
                );


       }

    }

    const handleDirectorChange = evt => {
        evt.preventDefault();


        var cntErr = 0;

        var errMsg = [];

        if (Director == null || Director == '') {
            cntErr += 1;
            errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุผู้ลงนามสูงสุด"}</li>);
        }

        if (cntErr > 0) {
            setErrMsg(errMsg);
            setModalError(true);
        } else {


            setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

            var body = {
                approveUserName: Director
            }
        }

        axios.put('/api/v1/leave/directorchange/' + LeaveApproveKey, body)
            .then(
                result => {

                    if (result.data.result == 200) {
                        setIcon("far fa-question-circle");
                        setModalApprove(false)
                        setModal2(true)
                    }
                    else {
                        setIcon("far fa-question-circle");
                        setModalApprove(false)
                        setErrMsg(result.data.msg)
                        setModalError(true)
                    }

                },
                error => { console.log(error); }
            );
    }


    //function renderFlowLevel(approve, index) {
const renderFlowLevel = (approve, index) => {
    
    var flow = FlowLevel.find(t => t.approveTypeKey == approve.approveTypeKey);

    var hr = LeaveApprove.find(t => t.approveTypeKey == 0);

    var flowTxt = '';
    var hrFlowTxt = '';
    var tmpDT = '';
    var tmpColor = '';
    var hrColor = '';
    if(approve.approveStatusKey == null ||approve.approveStatusKey == 0)
    {
      flowTxt = (flow != null) ? flow.flowName : '';  
    }
    else if (approve.approveStatusKey == 1)
    {
      flowTxt = (flow != null) ? 'รอ'+flow.flowName+flow.flowActorName : '';
      tmpColor = '#ff9800';
    }
    else if (approve.approveStatusKey == 2)
    {
      flowTxt = (flow != null) ? flow.flowName+flow.flowFinishName : '';
      tmpColor = '#4caf50';
    }
    else if (approve.approveStatusKey == -1)
    {
      flowTxt = (flow != null) ? flow.flowName+flow.flowRejectName : '';
      tmpColor = '#f44336';
    }
    else{

    }

    if(hr != null)
    {
      if(hr.approveStatusKey == null || hr.approveStatusKey == 0)
      {
        hrFlowTxt = '';  
      }
      else if (hr.approveStatusKey == 1)
      {
          //hrFlowTxt = (flow != null) ? 'รองานทรัพย์ฯตรวจสอบ' : '';
          hrFlowTxt = 'รองานทรัพย์ฯตรวจสอบ';
        hrColor = '#ff9800';
      }
      else if (hr.approveStatusKey == 2)
      {
        hrFlowTxt = (flow != null) ? 'งานทรัพย์ตรวจสอบแล้ว' : '';
        hrColor = '#4caf50';
      }
      else if (hr.approveStatusKey == -1)
      {
        hrFlowTxt = (flow != null) ? 'งานทรัพย์ไม่อนุญาต' : '';
        hrColor = '#f44336';
      }
      else{
        
      }
    }

    var dt = moment(approve.approveDT).isValid() ? moment(approve.approveDT).format("D MMM BB HH:mm") : '';

    var hrDT = (hr != null && moment(hr.approveDT).isValid()) ? moment(hr.approveDT).format("D MMM BB HH:mm") : '';

    const minItem = LeaveApprove.reduce((prev, current) => (prev.approveTypeKey < current.approveTypeKey) ? prev : current);
    
    return <div key={index}>
        {(approve.approveTypeKey == 0 && LeaveApprove.find(t => t.approveTypeKey >= 2 && t.approveTypeKey <= 4) == null) ?
        <>
                <Hidden xsDown key={"HR01"}>
                    <TimelineItem>
                        <TimelineOppositeContent>
                            <Typography style={{ color: hrColor }}>{hrFlowTxt}</Typography>
                            <Typography variant="body2" color="textSecondary">
                                {hrDT}
                            </Typography>
                        </TimelineOppositeContent>
                        <TimelineSeparator style={{ height: '120px' }}>
                            <TimelineDot color="primary" variant="outlined">
                                <Avatar alt={"chutikarn"} src={"https://e.trangskin.go.th/avatar/chutikarn.jpg"} className={classes.largeAvatar} />
                            </TimelineDot>

                            {(hr.approveStatusKey == 2) ?
                                <TimelineConnector />
                                :
                                <></>
                            }


                        </TimelineSeparator>
                        <TimelineContent>
                            <Paper elevation={3} className={classes.paper}>
                                {(hr.userView != null) ?
                                    <>
                                        <Typography>{hr.approveDescription}</Typography>
                                        <Typography>{hr.userView.firstName} {hr.userView.lastName} </Typography>
                                    </> : <></>
                                }


                                {
                                    (isHR && hr.approveStatusKey == 1) ?
                                        <Button
                                            variant="contained"
                                            color="info"
                                            startIcon={<i className={"fa fa-thumbs-up"}></i>}
                                            onClick={e => {
                                                setApproveDescription('');
                                                setModalHRApprove(true);
                                                setLeaveApproveKey(hr.leaveApproveKey);
                                            }
                                            }
                                        >
                                            อนุญาต
                    </Button> : <></>
                                }
                            </Paper>
                        </TimelineContent>
                    </TimelineItem>
                </Hidden>
                <Hidden smUp key={"HR02"}>
                    <Grid style={{ paddingTop: '10px' }}>
                        <Col xs={12} sm={12} md={12} >
                            <Avatar alt={"chutikarn"} src={"https://e.trangskin.go.th/avatar/chutikarn.jpg"} /*src={"https://e.trangskin.go.th/avatar/surasee.jpg"}*/ className={classes.largeAvatar} />
                            <Typography style={{ color: hrColor }}>{hrFlowTxt}</Typography>
                            {hrDT}
                            {(hr.userView != null) ?
                                <>
                                    <Typography>{hr.approveDescription}</Typography>
                                    <Typography>{hr.userView.firstName} {hr.userView.lastName} </Typography>
                                </> : <></>
                            }
                            {
                                (isHR && hr.approveStatusKey == 1) ?
                                    <Button
                                        variant="contained"
                                        color="info"
                                        startIcon={<i className={"fa fa-thumbs-up"}></i>}
                                        onClick={e => {
                                            setModalHRApprove(true);
                                            setLeaveApproveKey(hr.leaveApproveKey);
                                        }
                                        }
                                    >
                                        อนุญาต
                       </Button> : <></>
                            }
                        </Col>
                    </Grid>
                </Hidden>
        </>
        :
        <></>
    }   

    {(approve.approveTypeKey != 0 && approve.approveUserName != null) ?
    <>
    <Hidden xsDown key={"D" + approve.leaveApproveKey}>
        <TimelineItem>
            <TimelineOppositeContent>
                <Typography style={{ color: tmpColor }}>{flowTxt}</Typography>
                <Typography variant="body2" color="textSecondary">
                    {dt}
                </Typography>
            </TimelineOppositeContent>
            <TimelineSeparator style={{ height: '120px' }}>
                <TimelineDot color="primary" variant="outlined">
                    <Avatar alt={approve.approveUserName} src={"https://e.trangskin.go.th/avatar/" + approve.approveUserName + ".jpg"} className={classes.largeAvatar} />
                </TimelineDot>
                {(approve.approveTypeKey != minItem.approveTypeKey && approve.approveTypeKey != 1) ?
                    <TimelineConnector />
                    :
                    <></>
                }


            </TimelineSeparator>
            <TimelineContent>
                <Paper elevation={3} className={classes.paper}>
                    <Typography>{approve.approveDescription}</Typography>
                                <Typography>{approve.userView.firstName} {approve.userView.lastName} {" "}
                                    {
                                        (isHR && approve.approveStatusKey == 1 && approve.isApprove == null) ?
                                            <Button
                                                variant="contained"
                                                color="info"
                                                startIcon={<i className={"fa fa-user-edit"}></i>}
                                                onClick={e => {
                                                    setModalDirector(true);
                                                    setLeaveApproveKey(approve.leaveApproveKey);
                                                    setApproveTypeKey(approve.approveTypeKey);
                                                }
                                                }
                                            ></Button> : <></>
                                    }
                    </Typography>
                    {
                        ((currentUser.userName == approve.approveUserName && approve.approveStatusKey == 1) || isHR) ?
                            <Button
                                variant="contained"
                                color="info"
                                startIcon={<i className={"fa fa-thumbs-up"}></i>}
                                onClick={e => {
                                    setModalApprove(true);
                                    setLeaveApproveKey(approve.leaveApproveKey);
                                    setApproveTypeKey(approve.approveTypeKey);
                                    setIsApprove(true);
                                    //#madarakung กดยอมรับหรืออนุญาติแล้วค่าเปลี่ยนทันที
                                    const nextIsApprove = true;
                                    //setApproveDescription(isApprove ? (approve.approveTypeKey != 5 ? 'เห็นควรอนุญาต' : 'ยอมรับ') : '')
                                    setApproveDescription( nextIsApprove ? (approve.approveTypeKey != 5 ? 'เห็นควรอนุญาต' : 'ยอมรับ') : '');
                                }
                                }
                            >
                                {approve.approveTypeKey != 5 ? "อนุญาต" : "ยอมรับ"}
                            </Button> : <></>
                    }
                    {/* #madarakung เพิ่มปุ่มไม่ยอมรับและเปลี่ยนคำจากอนุมัติเป็นอนุญาต */}
                    {    
                        ((currentUser.userName == approve.approveUserName && approve.approveStatusKey == 1 && approve.approveTypeKey == 5) || isHR) ?
                            <Button
                                variant="contained"
                                color="danger"
                                startIcon={<i className={"fa fa-thumbs-down"}></i>}
                                onClick={e => {
                                    setModalApprove(true);
                                    setLeaveApproveKey(approve.leaveApproveKey);
                                    setApproveTypeKey(approve.approveTypeKey);
                                    setIsApprove(false);
                                    setApproveDescription(isApprove ? (approve.approveTypeKey != 5 ? '' : '') : '')
                                }
                                }
                            >
                                {approve.approveTypeKey != 5 ? "ไม่อนุญาต" : "ไม่ยอมรับ"}
                            </Button> : <></>
                    }
                </Paper>
            </TimelineContent>
        </TimelineItem>
    </Hidden>
    <Hidden smUp key={"U" + approve.leaveApproveKey}>
        <Grid style={{ paddingTop: '10px' }}>
            <Col xs={12} sm={12} md={12} >
                <Avatar style={{ float: 'left', marginLeft: '5px', marginRight: '20px', marginTop: '10px' }} alt={approve.approveUserName} src={"https://e.trangskin.go.th/avatar/" + approve.approveUserName + ".jpg"} className={classes.largeAvatar} />
                <Typography style={{ color: tmpColor }}>{flowTxt}</Typography>
                {dt}
                <Typography>{approve.approveDescription}</Typography>
                <Typography>{approve.userView.firstName} {approve.userView.lastName} </Typography>
                {
                    (approve.approveStatusKey == 1) ?
                        <Button
                            variant="contained"
                            color="info"
                            startIcon={<i className={"fa fa-thumbs-up"}></i>}
                            onClick={e => {
                                setModalApprove(true);
                                setLeaveApproveKey(approve.leaveApproveKey);
                                setApproveTypeKey(approve.approveTypeKey);
                                setApproveDescription(!isApprove ? (approve.approveTypeKey != 5 ? 'เห็นควรอนุญาต' : 'รับทราบ') : '')
                            }
                            }
                        >
                            อนุญาต
                        </Button> : <></>
                }
            </Col>
        </Grid>
    </Hidden>
    </>
    :
    <></>
    }    

    {(approve.approveTypeKey == 2 && approve.approveStatusKey == 2 && hr != null) ?
        <>
            <Hidden xsDown key={"HR01"}>
                <TimelineItem>
                    <TimelineOppositeContent>
                        <Typography style={{ color: hrColor }}>{hrFlowTxt}</Typography>
                        <Typography variant="body2" color="textSecondary">
                            {hrDT}
                        </Typography>
                    </TimelineOppositeContent>
                    <TimelineSeparator style={{ height: '120px' }}>
                        <TimelineDot color="primary" variant="outlined">
                            <Avatar alt={"chutikarn"} src={"https://e.trangskin.go.th/avatar/chutikarn.jpg"} className={classes.largeAvatar} />
                        </TimelineDot>

                        {(hr.approveStatusKey == 2) ?
                            <TimelineConnector />
                            :
                            <></>
                        }


                    </TimelineSeparator>
                    <TimelineContent>
                        <Paper elevation={3} className={classes.paper}>
                            {(hr.userView != null) ?
                                <>
                                    <Typography>{hr.approveDescription}</Typography>
                                    <Typography>{hr.userView.firstName} {hr.userView.lastName} </Typography>
                                </> : <></>
                            }


                            {
                                (isHR && hr.approveStatusKey == 1) ?
                                    <Button
                                        variant="contained"
                                        color="info"
                                        startIcon={<i className={"fa fa-thumbs-up"}></i>}
                                        onClick={e => {
                                            setApproveDescription('');
                                            setModalHRApprove(true);
                                            setLeaveApproveKey(hr.leaveApproveKey);
                                        }
                                        }
                                    >
                                        อนุญาต
                    </Button> : <></>
                            }
                        </Paper>
                    </TimelineContent>
                </TimelineItem>
            </Hidden>
            <Hidden smUp key={"HR02"}>
                <Grid style={{ paddingTop: '10px' }}>
                    <Col xs={12} sm={12} md={12} >
                        <Avatar alt={"chutikarn"} src={"https://e.trangskin.go.th/avatar/chutikarn.jpg"} /*src={"https://e.trangskin.go.th/avatar/surasee.jpg"}*/ className={classes.largeAvatar} />
                        <Typography style={{ color: hrColor }}>{hrFlowTxt}</Typography>
                        {hrDT}
                        {(hr.userView != null) ?
                            <>
                                <Typography>{hr.approveDescription}</Typography>
                                <Typography>{hr.userView.firstName} {hr.userView.lastName} </Typography>
                            </> : <></>
                        }
                        {
                            (isHR && hr.approveStatusKey == 1) ?
                                <Button
                                    variant="contained"
                                    color="info"
                                    startIcon={<i className={"fa fa-thumbs-up"}></i>}
                                    onClick={e => {
                                        setModalHRApprove(true);
                                        setLeaveApproveKey(hr.leaveApproveKey);
                                    }
                                    }
                                >
                                    อนุญาต
                       </Button> : <></>
                        }
                    </Col>
                </Grid>
            </Hidden>
        </>
        :
        <></>
    }    
    
           
</div>
}



  function renderDay2(props, currentDate, selectedDate) {
    var holiday = holidays.find(h => moment(h.holidayDate).format("YYYYMMDD") === moment(currentDate).format("YYYYMMDD"))
    var hdt = (holiday != null) ? holiday.name : '';

    // Adds 0 to the days in the days view
    if ((props.className.indexOf('rdtDisabled') >= 0) && (currentDate.day() !== 0 && currentDate.day() !== 6 && moment(currentDate) >= moment(StartDate)  )) {
        props.className += ' text-danger';
        //return <td {...props} style={{ textDecoration: 'Line-Through' }}>{currentDate.date()}</td>;
        return <td key={currentDate} >
            <button
                onClick={e => handleHoliday(hdt)}
                className="btn btn-danger btn-icon btn-round" style={{ background: 'red' }}
            >
                <span className="text-white" style={{ textDecoration: 'Line-Through' }}>{currentDate.date()}</span>
            </button>
        </td>; 
    }
    else {
        return <td {...props}>{currentDate.date()}</td>;
    }
}



    const classes = useStyles();

    if (!currentUser || !currentUser.token) {
      return <Redirect to="/auth/logout" />;
    }

    return (

        <div>
            <Grid>

                <Col xs={12} sm={12} md={12}>
                {/* <Card style={{display: ((isEdit && !isHR && currentUser.userName != UserName) ? 'none' : '')}}> */}
                <Card>
                        <CardHeader color="primary">

                            <h4 className={classes.cardTitleWhite}>แบบฟอร์มขออนุมัติลา</h4>
                            <p className={classes.cardCategoryWhite}> กรุณาระบุรายละเอียด </p>

                        </CardHeader>

                        <CardBody>
                             <Grid style={{ display: ((isCancel) ? '' : 'none') }}>
                                <Col xs={12} sm={12} md={12} style={{ background: 'red' }} >
                                    
                                    <h4 style={{color:'white', fontSize:'24px', textAlign:'center'}}>ยกเลิกการลาแล้ว</h4>
                                   
                                </Col>
                            </Grid>
                            <Grid>
                            {/* <Col xs={12} sm={12} md={12}>
                              <Label>{FullName} {TypeGovName} ตำแหน่ง{PositionName} สังกัด {GroupText}</Label>
                            </Col> */}
                              { isEdit && ( 
                              <><Col xs={12} sm={12} md={12}>
                      <Input
                        id="FullName"
                        cols="80"
                        name="FullName"
                        placeholder=""
                        rows="2"
                        type="textarea"
                        className="custom"
                        style={{ fontSize: '1.2em', maxHeight: '150px' }}
                        disabled="true"
                        value={FullName + " " + TypeGovName + " ตำแหน่ง" + PositionName + " สังกัด " + GroupText}
                      >
                      </Input>
                    </Col>
                    <Col xs={12} sm={12} md={12} style={{ marginTop: '15px' }}>
                        <Avatar alt={UserName} src={"https://e.trangskin.go.th/avatar/" + UserName + ".jpg"} className={classes.biggerAvatar} />
                      </Col></>
                            )}
                            {/* <Col xs={12} sm={12} md={12}>
                              <TSText label="ชือ" value={FullName + " " + TypeGovName + " ตำแหน่ง" + PositionName + " สังกัด " + GroupText} disabled={true} />
                            </Col> */}
                                <Col xs={12} sm={6} md={6}>
                                    <TSSelect2 label="ประเภทการลา" options={ArrLeaveType} value={LeaveTypeKey} onChange={e => handleLeaveType( ArrLeaveType, e.value, StartDate) } />
                                </Col>
                                
                                <Col xs={12} sm={6} md={6} container alignItems="center">
                                  <Grid>
                                    <Col xs={12} sm={12} md={12} style={{display: ((EnabledUrgent) ? '' : 'none')}}>
                                            <Label style={{ marginLeft: '35px' }} ><Input style={{ marginTop: 0, width: '20px', height: '20px', border: '1px solid black' }} checked={IsUrgent} type="checkbox" onChange={() => { setIsUrgent(!IsUrgent); setStartDate(''); setEndDate(''); setIsMoreDate(false);}} />&nbsp;&nbsp;ลาฉุกเฉิน</Label> 
                                    </Col>
                                    <Col xs={12} sm={12} md={12}>
                                      <Label style={{ marginLeft: '20px' }}>{LeaveHistory}</Label>
                                    </Col>             
                                    <Col xs={12} sm={12} md={12}>
                                      {
                                      ((LeaveTypeKey == 2 && !IsUrgent) || LeaveTypeKey == 3) ? 
                                      <Label style={{ marginLeft: '20px' }}>(ต้องลาล่วงหน้าอย่างน้อย {RequestBefore} วันทำการ)</Label>
                                      :
                                      <> </>
                                      }
                                    </Col>


                                    
                                  </Grid>
                                </Col>

                            </Grid>



                            <Grid>
                                <Col xs={8} sm={6} md={6}>
                                  <Label>วันที่ลา</Label>
                                  <FormGroup
                                        style={{ padding: '0 0px', marginBottom: '10px' }}
                                        className={
                                            "input-lg" + (dateFocus ? " input-group-focus" : "")
                                        }
                                    >
                                        <i className="far fa-calendar-check fa-2x" style={{
                                            position: 'absolute',
                                            left: '30px',
                                            zIndex: 1,
                                          
                                        }}
                                        ></i>

                                          <Datetime
                                              value={moment(StartDate).isValid() ? moment(StartDate) : null}
                                              renderYear={function (props, year, selectedDate) { return <td {...props}>{year + 543}</td>; }}
                                              isValidDate={isDateValid}
                                              renderDay={renderDay}
                                              //onBeforeNavigate={(a, b, c) => handleNavigate(a, b, c)}
                                              //onNavigateForward={(dayAmt, unit) => handleCurrentDate(dayAmt, unit)}
                                              //onNavigateBack={(dayAmt, unit) => handleCurrentDate((-1 * dayAmt), unit)}
                                              inputProps={{
                                                  name: "StartDate", placeholder: "วันที่ลา", readOnly: 'readonly'
                                                  , style: {
                                                      fontSize: '1.2em', borderRadius: 0, paddingLeft: '50px', cursor: 'pointer', background: '#ffffff', color: '#000000'
                                                  },
                                                  value: moment(StartDate).isValid() ? moment(StartDate).format('D MMMM BBBB') : ''                                                
                                              }}
                                              closeOnSelect={true}
                                              closeOnTab={true}
                                              dateFormat="D MMMM BBBB" timeFormat={false}
                                              //dateFormat="D MMMM BBBB" timeFormat="เวลา HH:mm น."
                                              //timeFormat={false}
                                              onFocus={() => setDateFocus(true)}
                                              onBlur={() => setDateFocus(false)}
                                              onChange={e => handleStartDate(e.format('YYYY-MM-DD'))}
                                              minDate={new Date("02-01-2020")}
                                              
                                        />
                                    </FormGroup>
                                </Col>

                                <Col xs={4} sm={6} md={6}>
                                  <TSSelect2 label="&nbsp;"  options={dateTypeList} value={StartType} onChange={e => handleStartType(e.value) } />
                                </Col>
                            </Grid>
                            <Grid  style={{display: ((moment(StartDate).isValid() && StartType != 1) ? '' : 'none')}}>
                                <Col xs={12} sm={6} md={6}> 
                                 <Label>ถึงวันที่   <Input style={{ marginTop: 0, marginLeft: '10px',width: '20px', height: '20px', border:'1px solid black' }} type="checkbox" checked={IsMoreDate} onChange={() => handleIsMoreDate(!IsMoreDate)} /></Label>         
                                </Col>
                            </Grid>
                            <Grid style={{display: ((!IsMoreDate || StartType == 1) ? 'none' : '')}}>
                                <Col xs={8} sm={6} md={6}> 
                                  <FormGroup
                                        style={{ padding: '0 0px', marginBottom: '10px', zIndex:1 }}
                                        className={
                                            "input-lg" + (dateFocus ? " input-group-focus" : "")
                                        }
                                    >
                                        <i className="far fa-calendar-check fa-2x" style={{
                                            position: 'absolute',
                                            left: '30px',
                                            zIndex: 1,
                                          
                                        }}
                                        ></i>

                                          <Datetime
                                              value={moment(EndDate).isValid() ? moment(EndDate) : null}
                                              renderYear={function (props, year, selectedDate) { return <td {...props}>{year + 543}</td>; }}
                                              isValidDate={isDateValid2}
                                              renderDay={renderDay2}
                                              inputProps={{
                                                  name: "EndDate", placeholder: "วันที่ลา", readOnly: 'readonly'
                                                  , style: {
                                                      fontSize: '1.2em', borderRadius: 0, paddingLeft: '50px', cursor: 'pointer', background: '#ffffff', color: '#000000'
                                                  },
                                                  value: moment(EndDate).isValid() ? moment(EndDate).format('D MMMM BBBB') : '' 
                                              }}
                                              closeOnSelect={true}
                                              closeOnTab={true}
                                              dateFormat="D MMMM BBBB" timeFormat={false}
                                              onFocus={() => setDateFocus(true)}
                                              onBlur={() => setDateFocus(false)}
                                              onChange={e => handleEndDate(e.format('YYYY-MM-DD'))}
                         
                                              
                                          />
                                    </FormGroup>
                                </Col>

                                <Col xs={4} sm={6} md={6}>
                                  <TSSelect2 label="" options={dateTypeList2} value={EndType} onChange={e => handleEndType(e.value) } />
                                </Col>
                            </Grid>

                            <Grid style={{display: ((moment(StartDate).isValid() || IsMoreDate) ? '' : 'none')}}>
                                <Col>
                                  <Label>จำนวนวันที่ลา</Label>
                                </Col>
                                <Col xs={8} sm={6} md={6}
                                 //onMouseEnter={() => setIsHovered(true)}
                                 //onMouseLeave={() => setIsHovered(false)}
                                >
                                            
                                {/*
                                <Fab color="primary" aria-label="add">
                                  <i className="far fa-calendar-minus fa-2x"></i>
                                </Fab>  

                                <Label>จำนวนการบาครั้งนี้ {TotalDate} วัน</Label>               
                                              
                                <Fab color="primary" aria-label="add">
                                  <i className="far fa-calendar-plus fa-2x"></i>
                                </Fab>  
                                */}

                                <Slider
                                      aria-label="Always visible"
                                      onChange={handleSliderChange}
                                      //onChangeCommitted={handleSliderChange}
                                      defaultValue={1}
                                      max={10}
                                      min={0.5}
                                      //getAriaValueText={valuetext}
                                      step={0.5}
                                      //marks={marks}
                                      valueLabelDisplay="on"
                                      //style={hiddenStyle}
                                      styles={{marginLeft: '10px'}}
                                      value={typeof TotalDate === 'number' ? TotalDate : 0}
                                      disabled={StartType == 1}
                                      //value={TotalDate}
                                    />
                                    
                                  </Col>
                            </Grid>

                            <Grid>
                              <Col xs={12} sm={12} md={12}>
                                <div className="textarea-container" style={{ padding: 0 }}>
                                      <Label for="Address">เหตุผลการลา </Label>  
                                          {/*(อ้างอิงจากที่อยู่ตอนลงทะเบียน, สามารถแก้ไขที่อยู่จัดส่งได้)*/}
                                      <Input
                                          id="LeaveReason"
                                          cols="80"
                                          name="LeaveReason"
                                          placeholder="เหตุผลการลา"
                                          rows="4"
                                          type="textarea"
                                          className="custom"
                                          style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                          value={LeaveReason}
                                          onChange={e => setLeaveReason(e.target.value) }
                                          ></Input>
                                  </div>
                              </Col>

                             
                            </Grid>
        
          

                            
                            <Grid>
                            <Col xs={12} sm={12} md={6}>
                                <div className="textarea-container" style={{ padding: 0 }}>
                                      <Label for="Address">สามารถติดต่อข้าพเจ้าได้ที่ </Label>  
                                          {/*(อ้างอิงจากที่อยู่ตอนลงทะเบียน, สามารถแก้ไขที่อยู่จัดส่งได้)*/}
                                      <Input
                                          id="ContactAddress"
                                          cols="80"
                                          name="ContactAddress"
                                          placeholder="ที่อยู่ที่ติดต่อได้สะดวก"
                                          rows="4"
                                          type="textarea"
                                          className="custom"
                                          style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                          value={ContactAddress}
                                          onChange={e => setContactAddress(e.target.value) }
                                          ></Input>
                                  </div>
                              </Col>
                              <Col xs={12} sm={12} md={6}>
                              <TSText label="หมายเลขโทรศัพท์" value={ContactPhone} onChange={e => setContactPhone(e.target.value)} />
                                      {/* แก้ให้ลากิจฉุกเฉินมีผู้ปฏิบัติงานแทนเหมือนลากิจปกติ */}
                                     {/* {(LeaveTypeKey == 3 || (LeaveTypeKey == 2 && !IsUrgent )) ?  */}
                                     {/* {(LeaveTypeKey == 3 || (LeaveTypeKey == 2)) ? */}
                                     {(LeaveTypeKey == 3 || (LeaveTypeKey == 2 && StartDate2 > currentDate)) ?
                                        <TSSelect2 isClearable={true} zIndex={7} label="ผู้ปฏิบัติงานแทน" options={ArrStandin} value={Standin} onChange={e => SetStandin(e != null ? e.value : '') } />
                                        :
                                        <></>         
                                    }

                            

                                    {(ArrDepartmentBoss.length > 0) ?
                                        <TSSelect2 isClearable={true} zIndex={6} label="หัวหน้างาน" options={ArrDepartmentBoss} value={DepartmentBoss} onChange={e => SetDepartmentBoss(e != null ? e.value : '')} />
                                        :
                                        <></>         
                                    }

                                    {(ArrGroupworkBoss.length > 0) ?
                                        <TSSelect2 isClearable={true} zIndex={5} label="หัวหน้ากลุ่มงาน" options={ArrGroupworkBoss} value={GroupworkBoss} onChange={e => SetGroupworkBoss(e!=null?e.value:'') } />
                                        :
                                        <></>
                                    }

                                    {(ArrMissionBoss.length > 0) ?   
                                        <TSSelect2 isClearable={true} zIndex={4} label="รองภารกิจ" options={ArrMissionBoss} value={MissionBoss} onChange={e => SetMissionBoss(e != null ? e.value : '') } />
                                        :
                                        <></>
                                    }
                              </Col>
                            </Grid>
                            <Grid>
                            <Col xs={12} sm={12} md={6}>
                                <div className="textarea-container" style={{ padding: 0 }}>
                                      <Label for="Address">เหตุผลการส่งใบลาล่าช้า </Label>  
                                          {/*(อ้างอิงจากที่อยู่ตอนลงทะเบียน, สามารถแก้ไขที่อยู่จัดส่งได้)*/}
                                      <Input
                                          id="LeaveReasonDelay"
                                          cols="80"
                                          name="LeaveReasonDelay"
                                          placeholder="เหตุผลการส่งใบลาล่าช้า"
                                          rows="4"
                                          type="textarea"
                                          className="custom"
                                          style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                          value={LeaveReasonDelay}
                                          onChange={e => setLeaveReasonDelay(e.target.value) }
                                          ></Input>
                                  </div>
                              </Col>
                              <Col xs={12} sm={12} md={6}>
                                <div className="textarea-container" style={{ padding: 0 }}>
                                      <Label for="Address">แนบ Link ใบรับรองแพทย์ </Label>  
                                          {/*(อ้างอิงจากที่อยู่ตอนลงทะเบียน, สามารถแก้ไขที่อยู่จัดส่งได้)*/}
                                      <Input
                                          id="MedicalCertificate"
                                          cols="80"
                                          name="MedicalCertificate"
                                          placeholder="แนบ Link ใบรับรองแพทย์"
                                          rows="2"
                                          type="textarea"
                                          className="custom"
                                          style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                          value={MedicalCertificate}
                                          onChange={e => setMedicalCertificate(e.target.value) }
                                          ></Input>
                                  </div>
                              </Col>
                            </Grid>

                            <Grid><Col>&nbsp;</Col></Grid>
                           
                            <Grid style={{ display: ((!isCancel && !isEdit && currentUser.userName != UserName) || (isEdit && currentUser.userName == UserName && LeaveApprove.length > 0 ? LeaveApprove[0].isApprove == null : false) || (isHR && !ApproveDirector) || (currentUser.userName == 'madarakung') ? '' : 'none') }}>
                            
                                {(location.state != null && location.state != '' && location.state.leaveRequestID != null && location.state.leaveRequestID != '') ? 
                                <Col xs={12} sm={12} md={5} style={{ height: "48px" }}>
                                    <Button color="warning" onClick={handleSubmit} fullWidth>
                                      <i className={"fa fa-edit"}  style={{ fontSize: "1.8em", padding:"0 5px 5px 0" }} ></i>
                                      <h4>แก้ไข</h4>
                                    </Button>
                                </Col>
                                :
                                <Col xs={12} sm={12} md={5} style={{ height: "48px" }}>
                                        <Button color="info" onClick={handleSubmit /*handleConfirmTest*/} fullWidth>
                                    <i className={"fa fa-save"}  style={{ fontSize: "1.8em", padding:"0 5px 5px 0" }} ></i>
                                    <h4>บันทึก</h4>
                                  </Button>
                                </Col>
                                }
                                
                                <Col xs={12} sm={12} md={2} >
                                  <>&nbsp;</>             
                                </Col>

                                <Col xs={12} sm={12} md={5} style={{ height: "48px" }}>
                                    <Button color="danger" onClick={() => { setModalCancel(true); }} fullWidth>
                                              <h4>ยกเลิกการลา</h4>
                                  </Button>
                                </Col>
                            </Grid>
                            {/* <Grid style={{ display: ((isCancel) ? '' : 'none') }}>
                                <Col xs={12} sm={12} md={12} style={{ background: 'red' }} >
                                    
                                    <h4 style={{color:'white', fontSize:'24px', textAlign:'center'}}>ยกเลิกการลา</h4>
                                   
                                </Col>
                            </Grid> */}

                      </CardBody>
                      <CardFooter>
                          <Collapse isOpen={isOpen}>

                          </Collapse>
                          {/* Confirm */}
                          <Modal toggle={() => {setModal(false); setIcon("far fa-question-circle");}} isOpen={modal}>
                            <div className="modal-header justify-content-center">
                              <div>
                                <i
                                  className={icon}
                                  style={{ color: "blue", fontSize: "2em" }}
                                ></i>
                              </div>
                            </div>
                            <ModalBody>
                              <p
                                style={{
                                  textAlign: "center"
                                }}
                              >
                                {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                  ? "ยืนยันการบันทึกข้อมูล"
                                  : "กำลังตรวจสอบข้อมูล"}
                              </p>
                              <p> </p>
                            </ModalBody>
                            <div className="modal-footer">
                            <Button
                                color="info"
                                type="button"
                                onClick={handleConfirm}
                                disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                              >
                                <h4>ยืนยัน</h4>
                              </Button>

                              <Button
                                color="danger"
                                type="button"
                                onClick={() => {setModal(false); setIcon("far fa-question-circle");}}
                              >
                                <h4>ยกเลิก</h4>
                              </Button>
 
                            </div>
                          </Modal>
                            {/* Approve */}
                            <Modal toggle={() => { setModalApprove(false); setIcon("far fa-question-circle"); }} isOpen={modalApprove}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={icon}
                                            style={{ color: "blue", fontSize: "2em" }}
                                        ></i> {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                            ? "ยืนยัน"
                                            : "กำลังตรวจสอบข้อมูล"}
                                    </div>
                              
                                </div>
                                <ModalBody>
                                    {/* #madarakung กดยอมรับหรืออนุญาติแล้วค่าเปลี่ยนทันที
                                    <TSCheckBox checked={isApprove} onChange={e => { setIsApprove(!isApprove); setApproveDescription(!isApprove ? (ApproveTypeKey !=5 ? 'เห็นควรอนุญาต':'รับทราบ') : '')}} />{(isApprove) ? <span style={{ color: 'green' }} >{ApproveTypeKey != 5 ? "อนุญาต" : "ยอมรับ"} </span> : <span style={{ color: 'red' }}>{ApproveTypeKey != 5 ? "ไม่อนุญาต" : "ไม่ยอมรับ"} </span>} */}
                                    <Input
                                        id="ApproveDescription"
                                        cols="80"
                                        name="ApproveDescription"
                                        placeholder="คำอธิบาย"
                                        rows="2"
                                        type="textarea"
                                        className="custom"
                                        style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                        value={ApproveDescription}
                                        onChange={e => setApproveDescription(e.target.value)}
                                    ></Input>
                                </ModalBody>
                                <div className="modal-footer">
                                    <Button
                                        color="info"
                                        type="button"
                                        onClick={handleApprove}
                                        disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                    >
                                        <h4>ยืนยัน</h4>
                                    </Button>

                                    <Button
                                        color="danger"
                                        type="button"
                                        onClick={() => { setModalApprove(false); setIcon("far fa-question-circle"); }}
                                    >
                                        <h4>ยกเลิก</h4>
                                    </Button>

                                </div>
                            </Modal>
                          
                            {/* HR Approve */}
                            <Modal toggle={() => { setModalHRApprove(false); setIcon("far fa-question-circle"); }} isOpen={modalHRApprove}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={icon}
                                            style={{ color: "blue", fontSize: "2em" }}
                                        ></i> {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                            ? "งานทรัพย์ยืนยันการตรวจสอบ"
                                            : "กำลังตรวจสอบข้อมูล"}
                                    </div>

                                </div>
                                <ModalBody>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <th>สถิติการลาในปีงบประมาณนี้</th>
                                            </tr>
                                            <tr>
                                                <th width="34%">ประเภทลา</th>
                                                <th width="22%">ลามาแล้ว</th>
                                                <th width="22%">ลาครั้งนี้</th>
                                                <th width="22%">รวม</th>
                                            </tr>
                                            <tr>
                                                <th id="thLeaveType">{ArrLeaveType.find(t => t.value == LeaveTypeKey)?.label || ""}</th>
                                                <td><TSText style={{ width: '95%' }} value={TotalHistory} onChange={e => setTotalHistory(e.target.value)} /></td>
                                                <td><TSText style={{ width: '95%' }} value={TotalDate} onChange={e => setTotalDate(e.target.value)} /></td>
                                                <td><TSText style={{ width: '95%' }} value={TotalAll} onChange={e => setTotalAll(e.target.value)} /></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <TSCheckBox checked={isApprove} onChange={e => setIsApprove(!isApprove)} />{(isApprove) ? <span style={{ color: 'green' }} >อนุญาต </span> : <span style={{ color: 'red' }}>ไม่อนุญาต </span>}



                                    <Input
                                        id="ApproveDescription"
                                        cols="80"
                                        name="ApproveDescription"
                                        placeholder="คำอธิบาย"
                                        rows="2"
                                        type="textarea"
                                        className="custom"
                                        style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                        value={ApproveDescription}
                                        onChange={e => setApproveDescription(e.target.value)}
                                    ></Input>

                                    <TSCheckBox checked={isReceiveMoney} onChange={e => setIsReceiveMoney(!isReceiveMoney)} />{(isReceiveMoney) ? <span style={{ color: 'green' }} >ได้รับเงินเดือน </span> : <span style={{ color: 'red' }}>ไม่ได้รับเงินเดือน </span>}

                                    {(!isReceiveMoney) ?
                                        <Input
                                            id="HRMoneyDesc"
                                            cols="80"
                                            name="HRMoneyDesc"
                                            placeholder="ไม่ได้รับเงินเดือนเนื่องจาก"
                                            rows="2"
                                            type="textarea"
                                            className="custom"
                                            style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                            value={HRMoneyDesc}
                                            onChange={e => setHRMoneyDesc(e.target.value)}
                                        ></Input>
                                        :
                                        <></>
                                    }

                                    <TSSelect2 label="ผู้อนุมัติระดับสูงสุด" options={ArrDirector} value={Director} onChange={e => SetDirector(e.value)} />
                                </ModalBody>
                                <div className="modal-footer">
                                    <Button
                                        color="info"
                                        type="button"
                                        onClick={handleHRApprove}
                                        disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                    >
                                        <h4>ยืนยัน</h4>
                                    </Button>

                                    <Button
                                        color="danger"
                                        type="button"
                                        onClick={() => { setModalHRApprove(false); setIcon("far fa-question-circle"); }}
                                    >
                                        <h4>ยกเลิก</h4>
                                    </Button>

                                </div>
                            </Modal>

                            {/* Director change */}
                            <Modal toggle={() => { setModalDirector(false); setIcon("far fa-question-circle"); }} isOpen={modalDirector}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={icon}
                                            style={{ color: "blue", fontSize: "2em" }}
                                        ></i> {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                            ? "เปลี่ยนผู้อนุมัติระดับสูงสุด"
                                            : "กำลังตรวจสอบข้อมูล"}
                                    </div>

                                </div>
                                <ModalBody>
                                    <TSSelect2 label="ผู้อนุมัติระดับสูงสุด" options={ArrDirector} value={Director} onChange={e => SetDirector(e.value)} />
                                </ModalBody>
                                <div className="modal-footer">
                                    <Button
                                        color="info"
                                        type="button"
                                        onClick={handleDirectorChange}
                                        disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                    >
                                        <h4>ยืนยัน</h4>
                                    </Button>

                                    <Button
                                        color="danger"
                                        type="button"
                                        onClick={() => { setModalDirector(false); setIcon("far fa-question-circle"); }}
                                    >
                                        <h4>ยกเลิก</h4>
                                    </Button>

                                </div>
                            </Modal>

                          
                          {/* Success */}
                         <Modal toggle={GotoEdit} isOpen={modal2}>
                            <div className="modal-header justify-content-center">
                              <div>
                                <i
                                  className={"fas fa-check"}
                                  style={{ color: "green", fontSize: "4em" }}
                                ></i>
                              </div>
                            </div>
                            <ModalBody>
                              <p
                                style={{
                                  textAlign: "center", fontSize: "1.8em"
                                }}
                              >
                               บันทึกข้อมูลสำเร็จ
                              

                              </p>
                              <p> </p>
                            </ModalBody>
                            <div className="modal-footer">
                              <Button
                                color="info"
                                type="button"
                                onClick={GotoEdit}
                              >
                                <i className={"fa fa-thumbs-up"} style={{ fontSize: "1.8em", padding:"0 5px 5px 0" }}></i>
                                <h4>ตกลง</h4>
                              </Button>

                             
                            </div>
                          </Modal>           


                            {/* Cancel */}
                            <Modal toggle={() => setModalCancel(false)} isOpen={modalCancel}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={icon}
                                            style={{ color: "red", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p
                                        style={{
                                            textAlign: "center", fontSize: "1.8em"
                                        }}
                                    >
                                        {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                            ? "ยืนยันยกเลิกการลา"
                                            : "กำลังตรวจสอบข้อมูล"}
                                    </p>
                                    <p> </p>
                                </ModalBody>
                                <div className="modal-footer">

                                    <Button
                                        color="success"
                                        type="button"
                                        onClick={handleCancel}
                                        disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                    >
                                        <i className={"fa fa-thumbs-up"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
                                        <h4>ยืนยัน</h4>
                                    </Button>

                                    <Button
                                        color="danger"
                                        type="button"
                                        onClick={() => { setIcon("far fa-question-circle"); setModalCancel(false); }}
                                    >
                                        <i className={"fa fa-thumbs-down"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
                                        <h4>ปฏิเสธ</h4>
                                    </Button>


                                </div>
                            </Modal>


                          {/* Error */}
                          <Modal toggle={() => setModalError(false)} isOpen={modalError}>
                            <div className="modal-header justify-content-center">
                              <div>
                                <i
                                  className="fa fa-times"
                                  style={{ color: "red", fontSize: "2em" }}
                                ></i>
                              </div>
                            </div>
                            <ModalBody>
                              <p>ไม่สามารถบันทึกข้อมูลได้</p>
                              {/*<div id='errMsg'>{errMsg}</div>*/}
                              <div dangerouslySetInnerHTML={{ __html: errMsg }} />
                            </ModalBody>
                            <div className="modal-footer justify-content-center">
                              <Button
                                color="primary"
                                type="button"
                                onClick={() => setModalError(false)}
                              >
                                <h4>ตกลง</h4>
                              </Button>
                            </div>
                          </Modal>
                      </CardFooter>
                  </Card>


                <Card style={{display: ((isEdit && !isCancel) ? '' : 'none')}}>
                        <CardHeader color="primary">

                            <h4 className={classes.cardTitleWhite}>ติดตามสถานะ การลา</h4>
                            <p className={classes.cardCategoryWhite}> </p>

                        </CardHeader>

                        <CardBody>
                            
                            <Grid>
                                <Col xs={12} sm={12} md={12} key={1} >
                                  <Timeline align="alternate">                                 
                                    {
                                      LeaveApprove.map((item, index) => (
                                          (item.approveTypeKey != 0 || true ) ?
                                        renderFlowLevel(item, index)
                                        :
                                        <p></p>
                                    ))}

                                  </Timeline>
                                </Col>
                            </Grid>
                        </CardBody>
                  </Card>

                    <Card style={{ position: 'relative', border: 0, height: window.innerHeight, display: ((isEdit & !isCancel) ? '' : 'none') }} >
                        <CardHeader color="primary">
                            {/* ใช้ div ครอบเพื่อจัด layout เป็นซ้าย-ขวา */}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                                {/* ส่วนข้อความ (ซ้าย) */}
                                <div>
                                    <h4 className={classes.cardTitleWhite}>ใบลา</h4>
                                    <p className={classes.cardCategoryWhite}> </p>
                                </div>

                                {/* ปุ่ม Save (ขวา) */}
                                <Button
                                    variant="contained"
                                    color="info"
                                    startIcon={<i className="fas fa-save" style={{ display: 'flex', alignItems: 'center' }}></i>}
                                    onClick={e => {
                                            window.open(`/pdf/leave/${_leaveRequestID}`, '_blank');
                                        }
                                    }
                                >
                                    ดาวน์โหลด
                                </Button>

                            </div>
                        </CardHeader>

                        {/* กำหนด height ให้ CardBody หรือ parent div เพื่อให้ PDF ขยายเต็มพื้นที่ที่เหลือ */}
                        <CardBody style={{ textAlign: 'center', height: 'calc(100% - 80px)', padding: 0 }}>

                            {/* เรียกใช้ PdfFile แบบ Embedded */}
                            <PdfFile
                                leaveRequestId={_leaveRequestID}
                                embedded={true}
                            />

                        </CardBody>
                    </Card>



                    
                    {/*
                    
                  <Hidden xsDown>
                    
                  </Hidden>         
                  <Hidden smUp>
                        <Card style={{ position: 'relative', border: 0, height: 150, display: ((isEdit & !isCancel) ? '' : 'none')}} >
                          <CardHeader color="primary">

                              <h4 className={classes.cardTitleWhite}>ใบลา</h4>
                              <p className={classes.cardCategoryWhite}>  </p>

                          </CardHeader>

                          <CardBody style={{textAlign:'center'}}>
                            <TSLeaveForm LeaveRequestID={_leaveRequestID}  />
                          </CardBody>
                    </Card>
                  </Hidden>       
                  */}
                

              </Col>
            </Grid>
        </div>
    );
}
export default Request;
